import * as React from 'react';
import { experimentalStyled as styled } from '@mui/material/styles';
import MuiButton from '@mui/material/Button';

const ButtonRoot = styled(MuiButton)(({ theme, size }) => ({
  borderRadius: 5,
  fontWeight: theme.typography.fontWeightMedium,
  fontFamily: theme.typography.h3.fontFamily,
  padding: theme.spacing(0.75, 2.5),
  fontSize: theme.typography.pxToRem(14),
  textTransform: 'none',
  boxShadow: 'none',
  '&:active, &:focus': {
    boxShadow: 'none',
  },
  ...(size === 'small' && {
    padding: theme.spacing(1, 3),
    fontSize: theme.typography.pxToRem(13),
  }),
  ...(size === 'large' && {
    padding: theme.spacing(2, 5),
    fontSize: theme.typography.pxToRem(16),
  }),
}));

function Button(props) {
  return <ButtonRoot {...props} />;
}

export default Button;